/**
 * head…tail mask: keeps the start and the end of a value visible so the
 * recognizable parts (origin, token suffix) survive while the middle is
 * elided. The full value should still be reachable via a copy button and/or
 * `title` attribute. Canonical call shapes: `midEllipsis(url, 18, 8)` for
 * webhook/connect URLs, `midEllipsis(secret, 4, 4)` for tokens/secrets.
 */
export function midEllipsis(s: string, head: number, tail: number): string {
  if (s.length <= head + tail + 1) return s;
  return `${s.slice(0, head)}…${s.slice(-tail)}`;
}

/**
 * Canonical URL display: drops the scheme (every destination is http(s), it
 * carries no information) and head…tail masks the rest, so the host start and
 * the path/token end stay visible. Full value belongs on copy button + title.
 */
export function midEllipsisUrl(url: string): string {
  return midEllipsis(url.replace(/^https?:\/\//i, ''), 18, 8);
}
